import React from "react";
import "./App.css";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

/* ---------- Analytics ---------- */
import AnalysisLogin from "./pages/analysis/AnalysisLogin";
import AnalysisLayout from "./pages/analysis/AnalysisLayout";
import AnalysisPage from "./pages/analysis/AnalysisPage";
import AnalysisStatsPage from "./pages/analysis/AnalysisStatsPage";
import FixtureDetailPage from "./pages/analysis/FixtureDetailPage";
import ArbitragePage from "./pages/analysis/ArbitragePage";
import ValueBetsPage from "./pages/analysis/ValueBetsPage";

/* ---------- Admin ---------- */
import AdminGuard from "./pages/admin/AdminGuard";
import AdminUsersPage from "./pages/admin/users/AdminUsersPage";

function AppShell() {
  return (
    <div className="app-blank min-h-screen">
      <Routes>
        <Route path="/" element={<Navigate to="/analysis" replace />} />

        <Route path="/analysis/login" element={<AnalysisLogin />} />

        <Route path="/analysis" element={<AnalysisLayout />}>
          <Route index element={<AnalysisPage />} />
          <Route path="arbitrage" element={<ArbitragePage />} />
          <Route path="value" element={<ValueBetsPage />} />
          <Route path="stats" element={<AnalysisStatsPage />} />
          <Route path="fixture/:fixtureId" element={<FixtureDetailPage />} />
        </Route>

        <Route
          path="/analysis/admin/users"
          element={
            <AdminGuard>
              <AdminUsersPage />
            </AdminGuard>
          }
        />

        <Route path="*" element={<Navigate to="/analysis" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}